<template>
  <!--
    blueOriginal
  -->
  <div class="navBar blueOriginal" style="position:fixed;top:0;">

    

    <div class="fullWidth" style="background:none;display:flex;">

      <div class="col25 colSm25 row rowm" @click="toHome()" style="background:none;flex-grow:2;">
        
          <img class="iconBrand" src="./../../../public/img/logoObscuro.png" style="margin-top:-5px;position:absolute;left:0;z-index:100;object-fit: cover;">
        
      </div>
      
      <div class="col48 row tCenter" style="background:none;flex-grow:5;margin-left:-10px;">
        <div class="block col95 tCenter" style="background:none;">
          <h3 class="navTitle" style="margin-bottom:3px;margin-top:10px;">
            Portal de Cursos 
          </h3>
        </div>
        <div class="block col95 center" style="padding-bottom:10px;background:none;">
          <h3 class="navTitle tCenter" style="margin-top:3px;">
            &nbsp;LAO
          </h3>
        </div>

      </div>

      

      <div class="row tRight" style="background:none;min-height:50px;margin:0px;margin-left:-25px;margin-top:10px;flex-grow:3;">

        <button class="btnBlueDark btnNoBackground" @click="toPoliticaBecas()">
          <i class="bi bi-book-fill btnIconSize"></i>
          <br>
          <small class="hideMobile">
            Programa de Becas
          </small>
        </button>
        
        <button class="btnBlueDark btnNoBackground" @click="optionMode=(optionMode==''?'CARRITO':'');" style="padding:0px;">
          <i class="bi bi-cart-fill btnIconSize"></i>
          
          <strong style="background:orange;border-radius:50px;padding:3px;margin-left:-5px;">
            <span>
            {{userStore.carritoCursos.length}}
            </span>
          </strong>
          <br>
          <small class="hideMobile">
            Carrito
          </small>
        </button>

        <button class="btnBlueDark btnNoBackground"  v-if="userStore.login==1" @click="toAlumnoHome()">
            
            <i class="bi bi-person-circle btnIconSize"></i>
          <br>
          <small class="hideMobile">
            Cuenta
          </small>
        </button>
        
        
        <button class="btnBlueDark btnNoBackground"  v-if="userStore.login==1" @click="optionMode=(optionMode==''?'MENU':'');">
          <i class="bi bi-list btnIconSize"></i>
          <br>
            <small class="hideMobile">
              Menú
            </small>
        </button>
        
        
        
        

        <button class="btnBlueDark btnNoBackground"  v-if="userStore.login==0"  @click="toLogin()">
          <!--
            <i class="bi bi-list" style="font-size:200%;"></i>
            -->
          <i class="bi bi-key-fill btnIconSize"></i>
          <br>
          <small class="hideMobile">
            Iniciar Sesión
          </small>
        </button>

        <!--
          @click="optionMode=(optionMode==''?'LOGOUT':'');" 
          -->

        <button class="btnBlueDark btnNoBackground"  v-if="userStore.login==0" @click="toNuevoRegistro()">
          <i class="bi bi-pencil-square btnIconSize"></i>
          <br>
          <small class="hideMobile">
            Registrar Cuenta
          </small>
        </button>

        <div 
        class="col25 colSm95 glass" 
        style=" 
        text-align:left;
        position:fixed;
        top:7%;
        right:0%;
        z-index:200;        
        min-height:20vh;
        background:rgba(256,256,256,0.4);
        color:black;
        " 
        v-if="optionMode=='CARRITO'||optionMode=='MENU'"
        >
          <div v-if="optionMode=='CARRITO'" style="max-height:30vh;padding:4px;">

            <div style="max-height:28vh;">
              <div>
                Carrito de Cursos:
                <button class="btn right" @click="optionMode='';">
                  <i class="bi bi-x-lg"></i>
                </button>
              </div>
              <div class="fullWidth" style="min-height:20vh;max-height:22vh;overflow-y:auto;">

                <strong v-if="userStore.carritoCursos.length==0">
                  Carrito de cursos vacio
                </strong>

                <div class="glassCarrito" style="margin-top:20px;border-radius:5px;padding:3px;" v-for="(curso,cI) in userStore.carritoCursos" :key="curso">
                  <strong>
                    {{cI+1}} ) {{curso.c1}} <i class="bi bi-trash-fill right" style="cursor:pointer;" @click="eliminarCursoDeCarrito(curso)"></i>
                  </strong>
                </div>
                <div style="min-height:100px;">
                  <span></span>
                </div>
              </div>
              <div class="fullWidth" v-if="userStore.carritoCursos.length>0">
                <button class="btnBlue fullWidth" @click="optionMode='';$root.changeRoute('nuevoAlumno');">
                  Inscribir a cursos en carrito
                </button>
              </div>
              
            </div>

          </div>

          <div v-if="optionMode=='MENU'" style="min-height:50dvh;padding:10px;border-radius:10px;background:rgba(02,91,173,0.9)">

            <div> 
              <div style="margin-top: 10px;color:white;">
                <strong>
                  Alumno:
                </strong>

                <button class="btnError right" @click="optionMode='';" style="width:8dvw;">
                  <i class="bi bi-x-lg"></i>
                </button>
              </div>

              <div class="tLeft" style="margin-top: 20px;">
                <label class="hideDesktop colSm90 rowm" style="margin-top:5px;line-height:12px;">                                
                  <strong style="font-family:fedrasanslight;color:var(--orange);">
                    {{userStore.userName}}
                  </strong>
                  
                  <label class="block" style="margin-top:5px;color:white;">
                    Usuario
                  </label>
                </label>
              </div>

              <div>
                <label class="hideDesktop colSm90 rowm" style="background:none;margin-top:5px;line-height:12px;">
                  <strong style="font-family:fedrasanslight;color:var(--orange);">
                    {{userStore.nombre+' '+userStore.ap1+' '+userStore.ap2}}
                  </strong>
                  
                  <label class="block" style="margin-top:5px;color:white;">
                    Nombre
                  </label>
                </label>
              </div>
              
              <div>
                <label class="hideDesktop colSm90 rowm" style="margin-top:5px;line-height:12px;">
                  <strong style="font-family:fedrasanslight;color:var(--orange);">
                    {{userStore.telefono}}
                  </strong>
                  
                  <label class="block" style="margin-top:5px;color:white;">
                    Teléfono
                  </label>
                </label>
              </div>

              <div>
                <label class="colSm90 row rowm" style="margin-top:5px;line-height:12px;">
                  <strong style="font-family:fedrasanslight;color:var(--orange);">
                    {{userStore.curp}}                
                  </strong>
                  
                  <label class="block" style="margin-top:5px;color:white;">
                    CURP
                  </label>
                </label>
              </div>

              <div>
                <label class="colSm90 row rowm" style="background:none;margin-top:5px;line-height:12px;">
                  <strong style="font-family:fedrasanslight;color:var(--orange);">
                    {{userStore.correo}}                
                  </strong>
                  
                  <label class="block" style="margin-top:5px;color:white;">
                    Correo Electrónico
                  </label>
                </label>
              </div>

              <div>
                <label class="colSm90 row rowm" style="background:none;margin-top:5px;line-height:12px;">
                  <strong style="font-family:fedrasanslight;color:var(--orange);">
                    {{userStore.relacionGrupoChedraui=='E'?'EXTERNO':userStore.relacionGrupoChedraui=='F'?'FAMILIAR':'COLABORADOR'}}
                  </strong>
                  
                  <label class="block" style="margin-top:5px;color:white;">
                    Relación Grupo Chedraui
                  </label>
                </label>
              </div>

            </div>

            <div style="margin-top:20px;color:white;">
              Menú:
            </div>
            
            <!--
            <div class="glassCarrito" style="cursor:pointer;border-radius:5px;padding:3px;margin-top:5px;">
              <i class="bi bi-key-fill"></i>
              Cambiar Contraseña
            </div>
            -->
            <div class="glassCarrito" style="cursor:pointer;border-radius:5px;padding:3px;margin-top:5px;color:white;" @click="optionMode='';$root.cleanData()">
              <i class="bi bi-door-closed-fill"></i>
              Cerrar Sesión
            </div>
          </div>
          

        </div>
        
        
      </div>
      
      
      
    </div>
  </div>
</template>

<script>
  
  import { mapStores } from 'pinia'
  import { useUserStore } from '../../store/user';
  


  export default {
  
    name: 'Navbar',
    props: {
      msg: String
    },
    data:function(){

      return{
        optionMode:''
      }

    },
    methods:{

      toPoliticaBecas(){
        this.$root.changeRoute("/programaBecas");
      },

      toNuevoRegistro(){

        this.$root.changeRoute("/nuevoAlumno");

      },

      eliminarCursoDeCarrito(curso){

        let l = this.userStore.carritoCursos.length;

        for(let i=0;i<l;i++){

          if(this.userStore.carritoCursos[i].c0==curso.c0){

            this.userStore.carritoCursos.splice(i,1);

          }

        }

      },

      toAlumnoHome(){
        if(this.userStore.plantel==''){

          this.userStore.plantel='XALAPA';
        }
        this.$root.changeRoute("/home");
      },

      toLogin(){
        if(this.userStore.plantel==''){

          this.userStore.plantel='XALAPA';
        }
        this.$root.changeRoute("/inicio");
      },

      toHome(){
        if(this.userStore.login!=1){
          this.userStore.login=0;
        }
        this.$root.changeRoute("/");
      }

    },
    computed:{
    
    ...mapStores(useUserStore)

    },
    
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.glassCarrito{
    
    background: rgba(255,255,255,0.30);    
    backdrop-filter: blur(2px);
    box-shadow: 0 8px 32px 0 rgba(31,38,135,0.37);
    
    margin: 0 auto;
    border-radius: 10px;
    padding:10px;    
    border: 1px solid rgba(255,255,255,0.18);
  
  }


</style>
